module.exports = __webpack_public_path__ + "static/img/afgchoice_tag.665e5ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afgchoice_tag.png
// module id = 7XYw
// module chunks = 1